import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import { colourScheme } from "../constants"

const Header = ({ siteTitle }) => (
  <header style={{ background: colourScheme.ink }}>
    <div
      style={{
        padding: `0 1.0875rem`,
      }}
    >
      <h1
        style={{
          float: "left",
          margin: 0,
          fontSize: "29px",
          height: `60px`,
          lineHeight: `60px`,
        }}
      >
        <Link
          style={{
            color: colourScheme.white,
            textDecoration: `none`,
          }}
          to="/"
        >
          {siteTitle}
        </Link>
      </h1>

      <div
        style={{
          marginLeft: "20px",
          float: "right",
          margin: 0,
          height: `60px`,
          lineHeight: `60px`,
          color: colourScheme.white,
          display: "flex",
          flexDirection: "column",
          textAlign: "right",
          justifyContent: "center"
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "20px",
            height: `20px`,
            lineHeight: `20px`,
            marginBottom: "5px",
            color: colourScheme.white,
          }}
        >
          made by{" "}
          <a
            style={{
              color: colourScheme.white,
            }}
            href="https://www.replastic.com"
            target="_blank"
          >
            replastic.com
          </a>
        </h1>
        <div
          style={{
            margin: 0,
            fontSize: "11px",
            height: `11px`,
            lineHeight: `11px`,
            color: colourScheme.white,
          }}>
          many thanks to{" "}
          <a
            style={{
              color: colourScheme.white,
            }}
            href="https://www.jackwolf.co.uk"
            target="_blank"
          >
            jackwolf.co.uk
          </a>{" "}
          &amp;{" "}
          <a
            style={{
              color: colourScheme.white,
            }}
            href="https://www.jowo.io"
            target="_blank"
          >
            jowo.io
          </a>
        </div>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
